<div class="any-betolt" *ngIf="!modell">
  <span *ngIf="!betoltesHiba">Nyomtatvány betöltése…</span>
  <span *ngIf="betoltesHiba" class="any-hibauz">{{ betoltesHiba }}</span>
</div>

<div class="any" *ngIf="modell && bev">
  <!-- Címsor: a nyomtatvány és a bevallás -->
  <div class="any-cimsor">
    <span class="any-kod">{{ modell.kod }}</span>
    <span class="any-nev">{{ modell.nev }}</span>
    <span class="any-ver">v{{ modell.verzio }}</span>
    <span class="spacer"></span>
    <span class="any-bev">{{ bev.cim }}</span>
  </div>

  <!-- Eszköztár (ÁNYK: Adatok / Ellenőrzések / Nyomtatás / Kapcsolatok) -->
  <div class="any-eszkoz">
    <button type="button" (click)="vissza()"><ion-icon name="arrow-back-outline"></ion-icon>Vissza</button>
    <span class="any-elv"></span>
    <button type="button" (click)="mentes()" [disabled]="ment || (zar && !zar.irhato)"><ion-icon name="save-outline"></ion-icon>Mentés <kbd>Ctrl+S</kbd></button>
    <button type="button" (click)="ellenoriz(true)"><ion-icon name="checkmark-done-outline"></ion-icon>Ellenőrzés <kbd>F6</kbd></button>
    <button type="button" (click)="hibalistaNyitva = !hibalistaNyitva" [class.aktiv]="hibalistaNyitva">
      <ion-icon name="list-outline"></ion-icon>Hibalista <span class="any-db" [class.nulla]="!hibaSzam">{{ hibaSzam }}</span></button>
    <span class="any-elv"></span>
    <span class="any-nezet" *ngIf="enyk">
      <button type="button" [class.aktiv]="nezet === 'tabla'" (click)="nezet = 'tabla'" title="Mezőcsoportok és ÁNYK-táblázatok"><ion-icon name="grid-outline"></ion-icon>Táblázatos</button>
      <button type="button" [class.aktiv]="nezet === 'lapkep'" (click)="nezet = 'lapkep'" title="A nyomtatvány lapjai, ahogy az ÁNYK-ban és papíron"><ion-icon name="document-outline"></ion-icon>Nyomtatványkép</button>
    </span>
    <span class="any-elv"></span>
    <button type="button" (click)="kovetkezo(-1)" [disabled]="aktBlokk === 0" title="Előző lap (Ctrl+PgUp)"><ion-icon name="chevron-back-outline"></ion-icon></button>
    <button type="button" (click)="kovetkezo(1)" [disabled]="aktBlokk >= blokkok.length - 1" title="Következő lap (Ctrl+PgDn)"><ion-icon name="chevron-forward-outline"></ion-icon></button>
    <span class="any-elv"></span>
    <button type="button" *ngIf="kitoltheto" (click)="elotolt(true)" [disabled]="elotoltFut || zarolt || (zar && !zar.irhato)"
            [title]="'Előtöltés: ' + kitoltheto + (bev?.kitoltve ? ' (utoljára: ' + (bev.kitoltve | date:'yyyy.MM.dd HH:mm') + ')' : '')">
      <ion-icon name="cloud-download-outline"></ion-icon>{{ elotoltFut ? 'Előtöltés…' : 'Előtöltés' }}</button>
    <!-- XML csak XSD-ből épült sablonnal készülhet (ONYA-/ÁNYK-forrásúnál nincs névtér és elemsorrend). -->
    <button type="button" *ngIf="bekuldheto" (click)="xmlLetolt()"
            title="A NAV XSD-je szerinti XML – gépi beküldéshez, vagy az ONYA XML-betöltésével"><ion-icon name="code-download-outline"></ion-icon>XML</button>
    <button type="button" *ngIf="bev?.m2m_bekuldve" (click)="m2mIgazolas()" title="Igazolás a gépi (M2M) beküldésről – PDF">
      <ion-icon name="document-text-outline"></ion-icon>Igazolás</button>
    <button type="button" *ngIf="bev" (click)="javitoKeszit()" title="Helyesbítés vagy önellenőrzés készítése ebből a bevallásból">
      <ion-icon name="git-branch-outline"></ion-icon>Javító…</button>
    <span class="cimke petrol" *ngIf="bev?.jelleg">{{ bev.jelleg === 'O' ? 'önellenőrzés' : 'helyesbítés' }}</span>
    <button type="button" (click)="nyomtat()"><ion-icon name="print-outline"></ion-icon>Nyomtatás</button>
    <span class="cimke sarga" *ngIf="gepiNemMegy"
          [title]="'A NAV sablontárában (nav-gov-hu-templates/' + (gepi?.tipus || bev?.kod) + ') még nincs XPath-állomány – amíg nincs, a NAV gépi úton nem fogadja. Utoljára nézve: ' + (gepi?.ellenorizve ? (gepi.ellenorizve | date:'yyyy.MM.dd HH:mm') : '—')">
      gépi beküldés még nem elérhető</span>
    <button type="button" *ngIf="bekuldheto" (click)="navEllenorzes()" [disabled]="m2mFut || zarolt"
            title="A NAV tartalmi ellenőrzése – beküldés nélkül">
      <ion-icon name="shield-checkmark-outline"></ion-icon>{{ m2mFut === 'ellenorzes' ? 'NAV ellenőrzés…' : 'NAV-ellenőrzés' }}</button>
    <button type="button" *ngIf="bekuldheto" [disabled]="m2mFut || zarolt || (zar && !zar.irhato)" (click)="bekuldes()"
            [class.eles]="m2mKornyezet === 'eles'"
            [title]="bekuldheto ? 'Beküldés a NAV ' + (m2mKornyezet === 'eles' ? 'ÉLES' : 'teszt') + ' környezetébe' : 'Ehhez a nyomtatványhoz nincs gépi beküldés'">
      <ion-icon name="paper-plane-outline"></ion-icon>{{ m2mFut === 'bekuldes' ? 'Beküldés…' : 'Beküldés (' + (m2mKornyezet === 'eles' ? 'ÉLES' : 'teszt') + ')' }}</button>
    <button type="button" *ngIf="bev?.m2m_azonosito" (click)="navAllapot()" [disabled]="m2mFut"
            title="A NAV-nál lévő ügy állapotának lekérdezése"><ion-icon name="sync-outline"></ion-icon>NAV-állapot</button>
    <button type="button" *ngIf="bev?.m2m_azonosito || bev?.m2m_allapot" (click)="navNaploNyit()"
            title="Minden NAV-válasz megőrizve: ellenőrzések, beküldés, állapotok – a beküldött XML-lel és a hibalistával"><ion-icon name="archive-outline"></ion-icon>NAV-napló</button>
    <button type="button" *ngIf="szerkesztheto && enyk" (click)="technikaiValt()" [class.aktiv]="technikaiMutat"
            title="Technikai mezők: nincsenek az XSD-ben, tehát nem kerülnek a beküldött adatba – csak a nyomtatványképhez tartoznak, kitölteni nem lehet őket">
      <ion-icon name="eye-outline"></ion-icon>Technikai mezők</button>
    <ng-container *ngIf="szerkesztheto">
      <span class="any-elv"></span>
      <button type="button" (click)="szerkMod = !szerkMod" [class.aktiv]="szerkMod" title="Fejlesztői nyomtatványszerkesztő: feliratok, súgó, karakterdobozok"><ion-icon name="construct-outline"></ion-icon>Elrendezés</button>
      <button type="button" *ngIf="elrPiszkos" (click)="elrMentes()" class="any-elr-ment"><ion-icon name="save-outline"></ion-icon>Elrendezés mentése</button>
    </ng-container>
    <span class="spacer"></span>
    <span class="any-allapot" [attr.data-allapot]="bev.allapot">{{ bev.allapot === 'ellenorzott' ? 'ellenőrzött' : bev.allapot === 'hibas' ? 'hibás' : bev.allapot }}</span>
    <span class="any-piszkos" *ngIf="piszkos">● nem mentett</span>
  </div>

  <app-szerk-zar-sav [zar]="zar"></app-szerk-zar-sav>

  <!-- XSD nélküli nyomtatvány: itt nem készül XML, megmondjuk, hol adható be (ONYA, a 65 az eÁFA). -->
  <div class="any-beadas" *ngIf="beadas">
    <ion-icon [name]="beadas.ut === 'eafa' ? 'swap-horizontal-outline' : 'globe-outline'"></ion-icon>
    <span>{{ beadas.uzenet }}</span>
  </div>

  <div class="any-test" [class.szerk]="szerkMod">
    <!-- LAPOK -->
    <aside class="any-lapok" *ngIf="nezet === 'lapkep' && enyk">
      <div class="any-form" *ngFor="let f of formok">
        <div class="any-form-fej">
          <span><b>{{ f.kod }}</b> {{ ismetlodo(f) ? '(' + (adat[f.nev]?.length || 0) + ' db)' : '' }}</span>
          <button type="button" *ngIf="ismetlodo(f)" (click)="ujPeldany(f); aktLap = 0; aktDin = 0" title="Új lap"><ion-icon name="add-outline"></ion-icon></button>
        </div>
        <ng-container *ngFor="let p of adat[f.nev]; let pi = index">
          <div class="any-peldany" *ngIf="ismetlodo(f)" [class.aktiv]="aktForm === f.nev && aktPeldany === pi">
            <button type="button" class="any-peldany-cim" (click)="lapra2(f.nev, pi, 0)">{{ peldanyCim(f, p, pi) }}</button>
            <button type="button" class="any-torol" (click)="peldanyTorol(f, pi)" title="Lap törlése"><ion-icon name="close-outline"></ion-icon></button>
          </div>
          <ng-container *ngIf="!ismetlodo(f) || (aktForm === f.nev && aktPeldany === pi)">
            <ng-container *ngFor="let o of enykForm(f.nev)?.oldalak || []; let oi = index">
              <button type="button" class="any-blokk" [class.bent]="ismetlodo(f)" [class.aktiv]="aktForm === f.nev && aktPeldany === pi && aktLap === oi"
                      [class.zart]="aktForm === f.nev && aktPeldany === pi && !lapNyithato(o)"
                      [title]="aktForm === f.nev && aktPeldany === pi && !lapNyithato(o) ? (lapAllapot[o.nev]?.ok || 'A lap a kitöltött adatok alapján nem nyitható meg.') : o.cim || o.nev"
                      (click)="lapra2(f.nev, pi, oi)">
                <span class="any-lapkod">{{ o.nev }}</span>
                <span class="any-lapcim">{{ o.dinamikus ? (dinDb(f.nev, p, o) + ' példány') : '' }}</span>
              </button>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </aside>
    <aside class="any-lapok" *ngIf="nezet !== 'lapkep' || !enyk">
      <div class="any-form" *ngFor="let f of formok">
        <div class="any-form-fej">
          <span><b>{{ f.kod }}</b> {{ ismetlodo(f) ? '(' + (adat[f.nev]?.length || 0) + ' db)' : '' }}</span>
          <button type="button" *ngIf="ismetlodo(f)" (click)="ujPeldany(f)" title="Új lap"><ion-icon name="add-outline"></ion-icon></button>
        </div>
        <ng-container *ngFor="let p of adat[f.nev]; let pi = index">
          <div class="any-peldany" *ngIf="ismetlodo(f)" [class.aktiv]="aktForm === f.nev && aktPeldany === pi">
            <button type="button" class="any-peldany-cim" (click)="lapra(f.nev, pi, 0)">{{ peldanyCim(f, p, pi) }}</button>
            <button type="button" class="any-torol" (click)="peldanyTorol(f, pi)" title="Lap törlése"><ion-icon name="close-outline"></ion-icon></button>
          </div>
          <ng-container *ngIf="!ismetlodo(f) || (aktForm === f.nev && aktPeldany === pi)">
            <button type="button" *ngFor="let b of f.elemek; let bi = index" class="any-blokk" [class.bent]="ismetlodo(f)"
                    [class.aktiv]="aktForm === f.nev && aktPeldany === pi && aktBlokk === bi" (click)="lapra(f.nev, pi, bi)">
              <span class="any-lapkod">{{ $any(b).lap || '' }}</span>
              <span class="any-lapcim">{{ blokkCim($any(b)) }}</span>
              <span class="any-db" *ngIf="blokkHibaDb(f.nev, pi, $any(b)) as db">{{ db }}</span>
            </button>
          </ng-container>
        </ng-container>
        <div class="any-ures-form" *ngIf="!adat[f.nev]?.length">Nincs lap – <a (click)="ujPeldany(f)">új lap</a></div>
      </div>
    </aside>

    <!-- NYOMTATVÁNYKÉP (ÁNYK-lap) -->
    <main class="any-lap any-lapkep" *ngIf="nezet === 'lapkep' && enyk">
      <div class="any-dinsav" *ngIf="lap?.dinamikus && peldany">
        <b>{{ lap.nev }}</b> – dinamikus lap:
        <button type="button" *ngFor="let d of dinIndexek(aktForm, peldany, lap)" [class.aktiv]="aktDin === d" (click)="aktDin = d">{{ d + 1 }}.</button>
        <button type="button" class="any-gomb" (click)="ujDinLap(aktForm, peldany, lap)" [disabled]="dinDb(aktForm, peldany, lap) >= lap.maxDb"><ion-icon name="add-outline"></ion-icon>Új példány</button>
      </div>
      <app-anyk-lap *ngIf="lap && peldany; else nincsLap2" [logo]="logo" [oldal]="lap" [hely]="anykKotes" [mezo]="anykMezo" [szamitott]="szamitottLap()" [szamitottOk]="szamitottOkLap()"
                    [technikaiMutat]="technikaiMutat" [matrixok]="enyk?.matrixok || {}" [metak]="enykMetak"
                    [csakOlvas]="!lapNyithato(lap)"
                    [hibak]="lapHiba" [kulcsElotag]="lapHibaElotag" (valtozott)="anykValtozott($event)" (fokusz)="anykFokusz($event)"></app-anyk-lap>
      <ng-template #nincsLap2>
        <div class="any-papir any-ures">Ehhez a részbizonylathoz még nincs lap.
          <button type="button" class="any-gomb" *ngIf="aktFormObj" (click)="ujPeldany(aktFormObj); aktLap = 0; aktDin = 0"><ion-icon name="add-outline"></ion-icon>Új lap</button></div>
      </ng-template>
    </main>

    <!-- A LAP -->
    <main class="any-lap" *ngIf="nezet !== 'lapkep' || !enyk">
      <div class="any-papir" *ngIf="blokk && peldany; else nincsLap">
        <div class="any-papir-fej">
          <div class="any-papir-kod">{{ modell.kod }}<small>{{ blokk.lap || aktFormObj?.kod }}</small></div>
          <div class="any-papir-cim">
            <h1>{{ blokkCim(blokk) }}</h1>
            <span>{{ aktFormObj?.cim }}<ng-container *ngIf="aktFormObj && ismetlodo(aktFormObj)"> · {{ peldanyCim(aktFormObj, peldany, aktPeldany) }}</ng-container></span>
          </div>
          <div class="any-papir-lapszam">{{ aktBlokk + 1 }}. / {{ blokkok.length }}</div>
        </div>
        <ng-container *ngFor="let e of blokk.elemek">
          <ng-container *ngTemplateOutlet="csomopont; context: { $implicit: e, ad: peldany, ut: '' }"></ng-container>
        </ng-container>
      </div>
      <ng-template #nincsLap>
        <div class="any-papir any-ures">Ehhez a részbizonylathoz még nincs lap.
          <button type="button" class="any-gomb" *ngIf="aktFormObj" (click)="ujPeldany(aktFormObj)"><ion-icon name="add-outline"></ion-icon>Új lap</button></div>
      </ng-template>
    </main>

    <!-- Fejlesztői elrendezés-szerkesztő -->
    <aside class="any-szerk" *ngIf="szerkMod">
      <h3><ion-icon name="construct-outline"></ion-icon>Elrendezés</h3>
      <p class="halvany">Csak a megjelenés változik (felirat, súgó, dobozok) – az XSD-szerkezet és a validáció nem. Minden bevallásra érvényes.</p>
      <div class="any-szerk-blokk" *ngIf="szerkBlokk as sb">
        <label>A lap címe<input type="text" [(ngModel)]="sb.cim" [placeholder]="blokk?.cim" (ngModelChange)="elrValtozott()"></label>
      </div>
      <ng-container *ngIf="fokusz && szerkMezo as sm; else nincsSzerkMezo">
        <div class="any-szerk-mezo"><b>{{ fokusz.kod }}</b><span *ngIf="fokusz.rovid"> · {{ fokusz.rovid }}</span><div class="halvany">{{ fokusz.cim }}</div></div>
        <label>Felirat<input type="text" [(ngModel)]="sm.cim" [placeholder]="fokusz.cim" (ngModelChange)="elrValtozott()"></label>
        <label>Súgó (a mező-információs sorban)<textarea rows="3" [(ngModel)]="sm.sugo" (ngModelChange)="elrValtozott()"></textarea></label>
        <label>Karakterdobozok száma (ÁNYK-szerű, 0 = sima mező)<input type="number" min="0" max="40" [(ngModel)]="sm.doboz" (ngModelChange)="elrValtozott()"></label>
        <label>Szélesség
          <select [(ngModel)]="sm.szeles" (ngModelChange)="elrValtozott()">
            <option [ngValue]="undefined">alapértelmezett</option><option value="kicsi">kicsi</option><option value="kozepes">közepes</option>
            <option value="szeles">széles</option><option value="teljes">teljes sor</option></select></label>
      </ng-container>
      <ng-template #nincsSzerkMezo><p class="halvany">Kattints egy mezőre a lapon.</p></ng-template>
      <button type="button" class="any-gomb" [disabled]="!elrPiszkos" (click)="elrMentes()"><ion-icon name="save-outline"></ion-icon>Elrendezés mentése</button>
    </aside>
  </div>

  <!-- NYOMTATÁS: a kitöltött lapok nyomtatványképe, lapszakítással (csak nyomtatáskor jelenik meg) -->
  <div class="any-nyomtat" *ngIf="nyomtatasFut">
    <div class="any-nyomtat-lap" *ngFor="let t of nyomtatasLapok"
         [style.width.px]="(t.oldal.w + 20) * t.arany" [style.height.px]="(t.oldal.h + 20) * t.arany">
      <div class="any-nyomtat-tart" [style.transform]="'scale(' + t.arany + ')'">
        <app-anyk-lap [oldal]="t.oldal" [hely]="t.hely" [mezo]="t.mezo" [csakOlvas]="true" [logo]="logo"
                      [matrixok]="enyk?.matrixok || {}" [metak]="t.metak"></app-anyk-lap>
      </div>
    </div>
  </div>

  <!-- Mező-információ (ÁNYK állapotsor) -->
  <div class="any-info">
    <ng-container *ngIf="fokusz; else nincsFokusz">
      <b>{{ fokusz.kod }}</b><span *ngIf="fokusz.rovid"> · {{ fokusz.rovid }}</span> — {{ mezoCim(fokusz) }}
      <span class="any-info-szabaly">{{ feliratTipus(fokusz) }}</span>
      <div class="any-sugo" *ngIf="mezoElr(fokusz).sugo">{{ mezoElr(fokusz).sugo }}</div>
    </ng-container>
    <ng-template #nincsFokusz><span class="halvany">Kattints egy mezőre a kódjáért és a szabályaiért.</span></ng-template>
  </div>

  <!-- Hibalista -->
  <div class="any-hibalista" *ngIf="hibalistaNyitva">
    <div class="any-hibalista-fej"><b>Hibalista</b> · {{ hibaSzam }} hiba<ng-container *ngIf="hibak.length - hibaSzam"> · {{ hibak.length - hibaSzam }} figyelmeztetés</ng-container>
      <span class="halvany"> · a hatályos XSD szerint</span>
      <span class="spacer"></span><button type="button" (click)="hibalistaNyitva = false"><ion-icon name="close-outline"></ion-icon></button></div>
    <div class="any-hibalista-test">
      <div class="any-hibasor" *ngFor="let h of hibak" (click)="hibahoz(h)" [class.figy]="h.szint === 'warning'">
        <span class="any-lapkod">{{ h.lap }}{{ h.lapIndex ? ' #' + (h.lapIndex + 1) : '' }}</span>
        <span class="any-hiba-hely">{{ form(h.form)?.kod }}{{ ismetlodo(form(h.form)!) ? ' ' + (h.peldany + 1) + '. lap' : '' }}{{ h.ut ? ' · ' + h.ut : '' }}</span>
        <span class="any-hiba-mezo">{{ h.mezo || '' }}</span>
        <span class="any-hiba-cim">{{ h.cim }}</span>
        <span class="any-hiba-uz">
          <b class="any-hibakod" *ngIf="h.kod">{{ h.kod }}</b>{{ h.uzenet }}</span>
      </div>
      <div class="any-hibasor ok" *ngIf="!hibak.length">A bevallás a mezőszabályok szerint hibátlan.</div>
      <div class="any-hibalab" *ngIf="hibak.length">
        Az ellenőrzés a nyomtatvány <b>hatályos XSD-sémáján</b> alapul – ugyanazon, amit a NAV a beküldéskor vár.
        A végső szót a „NAV-ellenőrzés” mondja ki, az a NAV saját rendszerében fut le.
      </div>
    </div>
  </div>
</div>

<!-- Egy csomópont a lapon: mezőcsoport (táblázattal), mező, ismétlődő sorok. `ad` az adatobjektum, `ut` az útja. -->
<ng-template #csomopont let-n let-ad="ad" let-ut="ut">
  <ng-container [ngSwitch]="n.tipus">
    <fieldset *ngSwitchCase="'csoport'" class="any-csoport">
      <legend *ngIf="n.cim">{{ n.cim }}</legend>
      <ng-container *ngFor="let sz of tabla(n).szakaszok">
        <!-- egyszerű mezők: tömör rács (felirat a mező fölött) -->
        <div class="any-racs" *ngIf="racsSzakasz(sz) as racs" cdkDropList cdkDropListOrientation="mixed" [cdkDropListDisabled]="!szerkMod"
             (cdkDropListDropped)="racsAthelyez(n, racs, $event)">
          <ng-container *ngFor="let m of racs">
            <div class="any-alfej" *ngIf="m._alfej && !szerkMod">{{ m._alfej }}</div>
            <div class="any-racsmezo" [attr.data-szeles]="racsSzeles(m)" [class.logikai]="m.adattipus === 'logikai'" cdkDrag [cdkDragDisabled]="!szerkMod"
                 [class.huzhato]="szerkMod">
              <span class="any-fogo" *ngIf="szerkMod" cdkDragHandle title="Mozgatás"><ion-icon name="reorder-three-outline"></ion-icon></span>
              <label [for]="mezoId(m, ut)"><span class="any-sorsz" *ngIf="m.sor">{{ m.sor }}.</span>{{ mezoCim(m) }}</label>
              <ng-container *ngTemplateOutlet="mezoBe; context: { $implicit: m, ad: ad, ut: ut }"></ng-container>
            </div>
          </ng-container>
        </div>
        <ng-container *ngIf="csomopontSzakasz(sz) as cs">
          <ng-container *ngTemplateOutlet="csomopont; context: { $implicit: cs, ad: ad, ut: ut }"></ng-container>
        </ng-container>
      </ng-container>
      <div class="any-tabla-wrap" *ngIf="tabla(n).sorok.length">
        <table class="any-tabla">
          <thead>
            <tr><th class="any-sorsz"></th><th class="any-sorcim"></th>
              <th *ngFor="let o of tabla(n).oszlopok" class="any-oszlop"><span class="any-betu">{{ o.betu }}</span><span class="any-oszlopcim">{{ o.cim !== o.betu ? o.cim : '' }}</span></th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let s of tabla(n).sorok">
              <td class="any-sorsz">{{ s.sor }}.</td>
              <td class="any-sorcim">{{ s.cim }}</td>
              <td *ngFor="let o of tabla(n).oszlopok" class="any-cella">
                <ng-container *ngIf="s.cellak[o.betu] as m">
                  <ng-container *ngTemplateOutlet="mezoBe; context: { $implicit: m, ad: ad, ut: ut }"></ng-container>
                </ng-container>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </fieldset>

    <div *ngSwitchCase="'mezo'" class="any-sor" [class.alcsoport]="n.elotag">
      <div class="any-alfej" *ngIf="n._alfej">{{ n._alfej }}</div>
      <label [for]="mezoId(n, ut)"><span class="any-sorsz" *ngIf="n.sor">{{ n.sor }}.</span>{{ mezoCim(n) }}</label>
      <ng-container *ngTemplateOutlet="mezoBe; context: { $implicit: n, ad: ad, ut: ut }"></ng-container>
    </div>

    <fieldset *ngSwitchCase="'lanc'" class="any-csoport any-lanc">
      <legend>{{ n.cim }} <span class="any-lanc-db">{{ lancSorok(n, ad).length }}{{ n.elemMax != null ? ' / ' + n.elemMax : '' }} sor</span></legend>
      <!-- fejléc (Chain_header) -->
      <div class="any-lanc-fej" *ngIf="n.fej?.length">
        <ng-container *ngFor="let e of n.fej">
          <ng-container *ngTemplateOutlet="csomopont; context: { $implicit: e, ad: lancFej(n, ad), ut: fejUt(ut, n) }"></ng-container>
        </ng-container>
      </div>
      <!-- egyszerű lánc: táblázat -->
      <div class="any-tabla-wrap" *ngIf="lancTablazatos(n) && lancSorok(n, ad).length">
        <table class="any-tabla">
          <thead><tr><th class="any-sorsz">#</th><th *ngFor="let m of lancMezok(n)" class="any-oszlop"><span class="any-oszlopcim">{{ mezoCim(m) }}</span></th><th></th></tr></thead>
          <tbody>
            <tr *ngFor="let sor of lancSorok(n, ad); let si = index">
              <td class="any-sorsz">{{ si + 1 }}.</td>
              <td *ngFor="let m of lancMezok(n)" class="any-cella">
                <ng-container *ngTemplateOutlet="mezoBe; context: { $implicit: m, ad: sor, ut: sorUt(ut, n, si) }"></ng-container>
              </td>
              <td class="any-cella"><button type="button" class="any-torol" (click)="lancTorol(n, ad, si)" title="Sor törlése"><ion-icon name="trash-outline"></ion-icon></button></td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- összetett lánc: soronként kártya, benne a teljes szerkezet (akár belső láncokkal) -->
      <ng-container *ngIf="!lancTablazatos(n)">
        <div class="any-lancsor" *ngFor="let sor of lancSorok(n, ad); let si = index">
          <div class="any-lancsor-fej"><b>{{ si + 1 }}. {{ n.cim }}</b>
            <button type="button" class="any-torol" (click)="lancTorol(n, ad, si)" title="Sor törlése"><ion-icon name="trash-outline"></ion-icon></button></div>
          <ng-container *ngFor="let e of n.elemek">
            <ng-container *ngTemplateOutlet="csomopont; context: { $implicit: e, ad: sor, ut: sorUt(ut, n, si) }"></ng-container>
          </ng-container>
        </div>
      </ng-container>
      <button type="button" class="any-gomb" (click)="lancUjSor(n, ad)" [disabled]="n.elemMax != null && lancSorok(n, ad).length >= n.elemMax"><ion-icon name="add-outline"></ion-icon>Új sor</button>
    </fieldset>

    <ng-container *ngSwitchDefault>
      <ng-container *ngFor="let e of n.elemek">
        <ng-container *ngTemplateOutlet="csomopont; context: { $implicit: e, ad: ad, ut: ut }"></ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<!-- Egy mező beviteli eleme (típus szerint), azonnali ellenőrzéssel -->
<ng-template #mezoBe let-m let-ad="ad" let-ut="ut">
  <div class="any-mezo" [class.hibas]="hibaja(m, ut)" [class.fokusz]="fokusz === m" [attr.data-tipus]="m.adattipus"
       [attr.data-szeles]="mezoElr(m).szeles || null" [class.dobozos]="(mezoElr(m).doboz || 0) > 0" [style.--doboz]="mezoElr(m).doboz || null"
       [class.szerk-jelolt]="szerkMod && fokusz === m" [title]="hibaja(m, ut) || mezoCim(m)">
    <div *ngIf="m.adattipus === 'logikai'" class="any-x" tabindex="0" [id]="mezoId(m, ut)"
         [class.szamitott]="szamitottE(m)" [title]="szamitottE(m) ? szamitottOk(m) : ''"
         (click)="xValt(m, ad, ut)"
         (keydown)="xBill($event, m, ad, ut)" (focus)="fokuszal(m)">{{ ad[m.kod] === true || ad[m.kod] === 'true' ? 'X' : '' }}</div>
    <select *ngIf="m.adattipus === 'kodlista'" [id]="mezoId(m, ut)" [(ngModel)]="ad[m.kod]" (ngModelChange)="valtozott(m, $event, ut)" (focus)="fokuszal(m)"
            [disabled]="szamitottE(m)" [class.szamitott]="szamitottE(m)" [title]="szamitottE(m) ? szamitottOk(m) : ''">
      <option [ngValue]="null"></option>
      <option *ngFor="let e of m.ertekek" [ngValue]="e.ertek">{{ ertekCimke(e) }}</option>
    </select>
    <input *ngIf="m.adattipus === 'datum'" type="date" [id]="mezoId(m, ut)" [(ngModel)]="ad[m.kod]" (ngModelChange)="valtozott(m, $event, ut)" (focus)="fokuszal(m)"
           [readonly]="szamitottE(m)">
    <input *ngIf="m.adattipus === 'szam' || m.adattipus === 'szoveg'" type="text" [id]="mezoId(m, ut)" [attr.inputmode]="m.adattipus === 'szam' ? 'numeric' : null"
           [attr.maxlength]="m.maxHossz || null" [(ngModel)]="ad[m.kod]" (ngModelChange)="valtozott(m, $event, ut)" (focus)="fokuszal(m)" autocomplete="off"
           [attr.list]="m.javasoltErtekek?.length ? 'jav-' + m.kod : null"
           [readonly]="szamitottE(m)" [class.szamitott]="szamitottE(m)" [title]="szamitottE(m) ? szamitottOk(m) : ''">
    <!-- Az ÁNYK-sablon listája javaslatként (ország, közterület jellege, helység, FEOR …). -->
    <datalist *ngIf="m.javasoltErtekek?.length" [id]="'jav-' + m.kod">
      <option *ngFor="let v of m.javasoltErtekek" [value]="v.ertek">{{ v.cim || '' }}</option></datalist>
    <span class="any-hibajel" *ngIf="hibaja(m, ut)">!</span>
    <!-- NAV-törzsadat visszajelzés az adószám-mezőkre (tájékoztatás, nem formai hiba). -->
    <span class="any-navjel" *ngIf="!hibaja(m, ut) && adoszamJelzes(m, ut) as j"
          [class.rossz]="!j.rendben" [title]="j.szoveg">{{ j.rendben ? '✓' : '?' }}</span>
  </div>
</ng-template>

<!-- NAV M2M napló: minden hívás a teljes válasszal (a NAV később nem adja vissza a beküldött bevallást). -->
<ion-modal [isOpen]="!!navNaplo" (didDismiss)="navNaplo = null" cssClass="sorablak-modal ber-szeles-modal">
  <ng-template>
    <ion-header><ion-toolbar><ion-title>NAV-napló – {{ bev?.kod }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="navNaplo = null"><ion-icon slot="icon-only" name="close"></ion-icon></ion-button></ion-buttons></ion-toolbar></ion-header>
    <ion-content class="ion-padding">
      <p class="halvany">A NAV a gépi felületen beküldött bevallást később nem adja vissza (az állapot 3 napig kérdezhető le) – ezért itt minden
        válasz megmarad. A hivatalos nyugta a cég tárhelyére érkezik.</p>
      <table class="n-racs" *ngIf="navNaplo?.length">
        <thead><tr><th>Időpont</th><th>Művelet</th><th>Környezet</th><th>Bizonylat</th><th>Ügyazonosító</th><th>Státusz</th><th>Letöltés</th></tr></thead>
        <tbody>
          <tr *ngFor="let n of navNaplo">
            <td>{{ n.idopont }}</td><td>{{ n.muvelet }}</td><td>{{ n.kornyezet }}</td><td>{{ n.bizonylat }}</td><td>{{ n.ugy_azonosito }}</td>
            <td>{{ n.statusz || n.result_code }}<div class="halvany" *ngIf="n.result_message">{{ n.result_message }}</div></td>
            <td style="white-space:nowrap">
              <button type="button" class="kv-mini" (click)="navNaploFajl(n, 'valasz')" title="A teljes NAV-válasz (JSON)"><ion-icon name="document-text-outline"></ion-icon></button>
              <button type="button" class="kv-mini" *ngIf="+n.van_xml" (click)="navNaploFajl(n, 'xml')" [title]="'A beküldött XML · SHA-256: ' + n.xml_sha256"><ion-icon name="code-outline"></ion-icon></button>
              <button type="button" class="kv-mini" *ngIf="n.hibalista_xml" (click)="navNaploFajl(n, 'hibalista')" title="A NAV hibalistája (kibontva)"><ion-icon name="warning-outline"></ion-icon></button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="ures" *ngIf="navNaplo && !navNaplo.length">Még nincs NAV-hívás ehhez a bevalláshoz.</div>
    </ion-content>
  </ng-template>
</ion-modal>
